<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  data: any; // The JSON data to display
  indent?: number; // Number of spaces for indentation (default: 2)
  backgroundColor?: string; // Background color for the container
  maxHeight?: string; // Maximum height of the container
}>();

// Set default values
const indent = props.indent ?? 2;
const backgroundColor = props.backgroundColor ?? "#f8f9fa";
const maxHeight = props.maxHeight ?? "800px";

// Format the JSON data
const formattedJson = computed(() => {
  try {
    // Handle both string and object inputs
    const dataToFormat = typeof props.data === "string" ? JSON.parse(props.data) : props.data;

    return JSON.stringify(dataToFormat, null, indent);
  } catch (error) {
    logError(error, {
      context: {
        feature: "json-viewer",
        step: "format",
      },
    });
    return `Error formatting JSON: ${error}`;
  }
});
</script>

<template>
  <div
    class="tw:rounded tw:p-4 tw:overflow-auto tw:font-mono tw:text-sm tw:border tw:border-gray-300 tw:!my-6"
    :style="{
      backgroundColor: backgroundColor,
      maxHeight: maxHeight,
    }"
    data-testid="json-viewer"
  >
    <pre
      class="tw:m-0 tw:whitespace-pre-wrap tw:break-all"
      data-testid="json-viewer-pre"
      >{{ formattedJson }}</pre
    >
  </div>
</template>
